import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#d4a74a] text-white hover:bg-[#b8903b] focus:ring-[#d4a74a] shadow-md hover:shadow-lg',
    secondary: 'bg-[#0f5f5f] text-white hover:bg-[#0a4545] focus:ring-[#0f5f5f] shadow-md',
    outline: 'border-2 border-white text-white hover:bg-white/10 focus:ring-white',
    ghost: 'text-[#0f5f5f] hover:bg-[#0f5f5f]/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-186">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-187" />}
      {children}
    </button>;
}